import React, { useEffect, useState } from "react";
import { getDocs, collection, doc, deleteDoc, orderBy, query, getFirestore, getDoc } from 'firebase/firestore';
import { useNavigate } from "react-router-dom";
//import styles from '../Styles/homepage.css';

function SeePost({postTitlex, postText, postFileLink, postImageLink, postFileName, postAuthor}) {

    let navigate = useNavigate();

    const saveData = () => {
        localStorage.setItem("lpostTitle", postTitlex);
        localStorage.setItem("lpostText", postText);
        localStorage.setItem("lpostFileLink", postFileLink);
        localStorage.setItem("lpostImageLink", postImageLink);
        localStorage.setItem("lFileName", postFileName);
        localStorage.setItem("lpostAuthor", postAuthor);
        navigate("/post");
    }

    return(
    <div>
        <button onClick={saveData} className="seePostBtn">
            <h1>zobacz całość</h1>
        </button>
    </div>
    );
}

export default SeePost;
